import script from "./menuCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./menuCard.vue?vue&type=script&setup=true&lang=ts"

import "./menuCard.vue?vue&type=style&index=0&id=58ff9569&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58ff9569"]])

export default __exports__